import { artUrl } from "../lib/artVersion";
import { Link } from "react-router-dom";
import { ROUTES } from "../lib/routes";

/**
 * 404 — 브랜드 페이지(FR-COM).
 * 이전엔 개발용 자리표시자(Placeholder)를 재사용해 "배지 404"만 떴다.
 * 영유아 서비스라 길 잃은 순간이 무섭지 않게 캐릭터가 맞아주고, 갈 곳을 크게 제시한다.
 * 캐릭터는 번들 정적(포토존과 공용) — 오프라인에서도 보인다.
 */
export default function NotFound() {
  return (
    <main className="notfound">
      <div className="notfound__card">
        <div className="notfound__chars" aria-hidden="true">
          <img src={artUrl("/art/photobooth/greg.png")} alt="" draggable={false} />
          <img src={artUrl("/art/photobooth/chick.png")} alt="" draggable={false} />
        </div>
        <h1>어라, 길을 잃었어요!</h1>
        <p>
          찾는 쪽지가 없어요. 그레그와 병아리가 <b>마을 입구</b>까지 데려다줄게요.
        </p>
        <div className="notfound__actions">
          <Link className="btn btn--primary" to={ROUTES.landing}>
            🏠 처음으로 가기
          </Link>
          <Link className="btn" to={ROUTES.world}>
            체험공간 구경하기
          </Link>
        </div>
      </div>
    </main>
  );
}
